import { Button } from '@driftt/tide-core-legacy'


const DisconnectButton = ({ isProcessing, onClick }) => (
  <Button type="tertiary" className="disconnect-integration-button" onClick={onClick} loading={isProcessing}>
    Disconnect
  </Button>
)

export default DisconnectButton



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/components/DisconnectButton/index.js